document.addEventListener("DOMContentLoaded", () => {
    const fadeEls = document.querySelectorAll(
        ".fade-in, .fade-in-left, .fade-in-right, .fade-in-top, .fade-in-bottom"
    );

    if (!fadeEls.length) return;

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("fade-in-visible");
                obs.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.2
    });

    fadeEls.forEach(el => observer.observe(el));
});

